<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Branch" :required="true">
              <b-form-select
                @blur="$v.adjustment.branch_id.$touch"
                :class="{ 'is-invalid': $v.adjustment.branch_id.$error }"
                v-model="adjustment.branch_id"
                :options="branches"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.adjustment.branch_id.required"
              >
                Please select branch
              </div>
            </form-group>

            <form-group label="Remark" :required="true">
              <input
                @blur="$v.adjustment.remark.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.adjustment.remark.$error }"
                v-model="adjustment.remark"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.adjustment.remark.required"
              >
                Please remark
              </div>
            </form-group>

            <form-group label="Pallets are damaged">
              <b-form-checkbox
                id="checkbox-1"
                v-model="adjustment.is_damaged"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group v-if="adjustment.is_damaged == 0" label="Operator">
              <b-form-radio-group
                v-model="adjustment.operator"
                :options="['Add', 'Subtract']"
                button-variant="outline-secondary"
                name="radio-btn-outline"
                buttons
              ></b-form-radio-group>
            </form-group>

            <form-group label="Quantity">
              <input
                type="number"
                step="1"
                min="0"
                v-model="adjustment.quantity"
                class="form-control"
              />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    adjustment: {
      remark: {
        required,
      },
      branch_id: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      adjustment: {
        is_damaged: 0,
        operator: "Add",
        quantity: 0,
      },
      branches: [],
      suppliers: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await palletRepo.branches();
        this.branches = data.branches;
        let res = await palletRepo.suppliers();
        this.suppliers = res.data.suppliers;

        if (this.branches.length > 0) {
          this.adjustment.branch_id = this.branches[0].id;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.adjustment.quantity == 0) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await palletRepo.createAdjustment(this.adjustment);
          this.$emit("palletAdjustmentCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Whoops", {
              title: "Something went wrong",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

